import * as React from "react"
import { Chip, Stack, Typography } from "@mui/material"

const COLORS = [
    "#1976d2", "#388e3c", "#f57c00", "#7b1fa2",
    "#c2185b", "#00796b", "#5d4037", "#455a64",
    "#d32f2f", "#303f9f"
]

// Shared with the availability columns so a customer keeps the same color
// across the row, whatever column it is read in.
export const getCustomerColor = (index) => COLORS[index % COLORS.length]

export default function customersColumn() {
    return {
        name: "customers",
        label: "Customers",
        options: {
            filter: true,
            filterType: "dropdown",
            sort: false,
            setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
            setCellProps: () => ({ style: { textAlign: "center" } }),
            customBodyRender: (value) => {
                if (!value || value.length === 0) {
                    return <Typography color="text.disabled">-</Typography>
                }
                return (
                    <Stack
                        direction="row"
                        spacing={0.5}
                        flexWrap="wrap"
                        justifyContent="center"
                        useFlexGap
                    >
                        {value.map((customer, index) => (
                            <Chip
                                key={customer}
                                label={customer}
                                size="small"
                                sx={{
                                    backgroundColor: getCustomerColor(index),
                                    color: "#fff",
                                    fontSize: "0.7rem",
                                    height: 22,
                                    mb: 0.5
                                }}
                            />
                        ))}
                    </Stack>
                )
            },
            customFilterListOptions: {
                render: (v) => `Customer: ${v}`
            }
        }
    }
}
